/** @file displayOf: a world point in display space, z scaled by zScaleView as render-core projects it. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `[x, y, z * zScaleView]`: the space the orthographic basis projects (render-core `projectOffset`, 17.7). */
export function displayOf(p: Vec3, zScaleView: number): Vec3 {
  return [p[0], p[1], p[2] * zScaleView];
}
